export default function reducer(
  state = {
    batchOrderReportUploadsList: [],
    totalItems: 0,
    fetching: false,
    fetched: false,
    error: null,
  },
  action,
) {
  switch (action.type) {
    case "FETCH_ORDER_REPORT_UPLOADS_LIST_PENDING": {
      return {
        ...state,
        fetching: true,
      };
    }
    case "FETCH_ORDER_REPORT_UPLOADS_LIST_REJECTED": {
      return {
        ...state,
        fetching: false,
        fetched: false,
        error: action.payload,
      };
    }
    case "FETCH_ORDER_REPORT_UPLOADS_LIST_FULFILLED": {
      return {
        ...state,
        fetching: false,
        fetched: true,
        batchOrderReportUploadsList: action.payload.data,
        error: null,
      };
    }
    case "FETCH_ORDER_REPORT_UPLOADS_TOTAL_PENDING": {
      return {
        ...state,
        fetchingTotal: true,
      };
    }
    case "FETCH_ORDER_REPORT_UPLOADS_TOTAL_REJECTED": {
      return {
        ...state,
        fetchingTotal: false,
        error: action.payload,
      };
    }
    case "FETCH_ORDER_REPORT_UPLOADS_TOTAL_FULFILLED": {
      const totalData = action.payload.data || [];
      return {
        ...state,
        fetchingTotal: false,
        totalItems: Array.isArray(totalData) ? totalData.length : 0,
        error: null,
      };
    }

    case "RESET_STATE": {
      return {
        ...state,
        fetching: false,
        fetched: false,
        error: null,
      };
    }

    default: {
      return { ...state };
    }
  }
}
